import { AutoLogout } from "@usher/pe-client-front-end-lib"
import { useIntl } from "react-intl"
import { Button } from "../Button"

export const LogoutPopup = () => {
  const intl = useIntl()
  return (
    <AutoLogout
      textYes={intl.formatMessage({ id: "logout_yes" })}
      textSec={intl.formatMessage({ id: "logout_sec" })}
      textTimer={intl.formatMessage({ id: "logout_timer" })}
      textWantToStay={intl.formatMessage({ id: "want_to_stay" })}
      textWillLogout={intl.formatMessage({ id: "will_logout" })}
      actionComponent={<Button style={{ minWidth: 100, width: "70%", margin: "0 auto" }}>Yes</Button>}
    />
  )
}
